import { render, staticRenderFns } from "./InlineAiPluginNotInstalled.vue?vue&type=template&id=67fa88d9&scoped=true&"
import script from "./InlineAiPluginNotInstalled.vue?vue&type=script&lang=ts&"
export * from "./InlineAiPluginNotInstalled.vue?vue&type=script&lang=ts&"
import style0 from "./InlineAiPluginNotInstalled.vue?vue&type=style&index=0&id=67fa88d9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fa88d9",
  null
  
)

export default component.exports